"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMedia = _interopRequireDefault(require("react-media"));
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _constants = require("../../constants");
var Gallery = function Gallery(_ref) {
  var noPadding = _ref.noPadding,
    children = _ref.children,
    title = _ref.title,
    text = _ref.text,
    toggle = _ref.toggle,
    cta = _ref.cta,
    noCloseIcon = _ref.noCloseIcon;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: !noPadding ? {
      padding: 'calc(var(--component-padding) * 2)',
      height: '100%'
    } : {
      padding: 0,
      height: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal--close-desktop",
    style: {
      top: 12,
      right: 14
    }
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    icon: "cross",
    buttonType: _constants.BUTTON_TYPES.BARE_WHITE,
    onClick: toggle,
    buttonSize: _constants.BUTTON_SIZES.LARGE
  })), children, !children && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center text-left@xs"
  }, title && /*#__PURE__*/_react["default"].createElement("h3", {
    className: "d8-u-ls-sm d8-u-color-primary text-md margin-bottom-md"
  }, title), text && /*#__PURE__*/_react["default"].createElement("p", null, text)));
};
Gallery.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  title: _propTypes["default"].string,
  text: _propTypes["default"].string,
  toggle: _propTypes["default"].func,
  cta: _propTypes["default"].object,
  noPadding: _propTypes["default"].bool,
  noCloseIcon: _propTypes["default"].bool
};
var _default = exports["default"] = Gallery;